import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import { api } from "../lib/api";

export default function Messaggi() {
  const [messages, setMessages] = useState([]);
  const [body, setBody] = useState("");
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);

  const load = () => api.get("/messages").then((r) => setMessages(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages]);

  const send = async (e) => {
    e.preventDefault();
    if (!body.trim()) return;
    setSending(true);
    try {
      const { data } = await api.post("/messages", { body });
      setMessages([...messages, data]);
      setBody("");
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="messaggi-page" className="flex h-[calc(100vh-13rem)] flex-col">
      <div className="mb-4">
        <h1 className="font-display text-3xl font-bold text-[#0A192F]">Messaggi</h1>
        <p className="mt-1 text-slate-600">Scrivi al team ViviTranquillo, ti rispondiamo durante l'anno.</p>
      </div>

      <div className="flex flex-1 flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white">
        <div className="flex-1 space-y-4 overflow-y-auto p-6">
          {messages.length === 0 ? (
            <p className="py-10 text-center text-slate-400">Nessun messaggio ancora.</p>
          ) : (
            messages.map((m) => (
              <div key={m.id} data-testid={`messaggio-${m.id}`} className={`flex ${m.from_staff ? "justify-start" : "justify-end"}`}>
                <div className={`max-w-[75%] rounded-2xl px-4 py-3 text-sm ${m.from_staff ? "bg-slate-100 text-slate-800" : "bg-[#10B981] text-white"}`}>
                  <p>{m.body}</p>
                  <p className={`mt-1 text-[10px] ${m.from_staff ? "text-slate-400" : "text-white/70"}`}>
                    {m.from_staff ? "ViviTranquillo" : "Tu"} · {new Date(m.created_at).toLocaleDateString("it-IT")}
                  </p>
                </div>
              </div>
            ))
          )}
          <div ref={endRef} />
        </div>

        <form onSubmit={send} className="flex items-center gap-3 border-t border-slate-200 p-4">
          <input data-testid="messaggio-input" value={body} onChange={(e) => setBody(e.target.value)} placeholder="Scrivi un messaggio..." className="flex-1 rounded-full border border-slate-200 px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#10B981]" />
          <button data-testid="messaggio-send" disabled={sending} className="flex h-11 w-11 items-center justify-center rounded-full bg-[#10B981] text-white transition-colors hover:bg-[#059669] disabled:opacity-60">
            <Send className="h-5 w-5" />
          </button>
        </form>
      </div>
    </div>
  );
}
